var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('grid-table',{ref:"gridTable",attrs:{"tableConfig":_vm.tableConfig,"buttonConfig":_vm.buttonConfig},on:{"selectionChange":_vm.handleSelectionChange,"handleButtonClick":_vm.callMethod}}),(_vm.dialogVisible)?_c('look-announcement',{ref:"lookDialog",on:{"handleQuery":_vm.handleQuery}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }